import { render, staticRenderFns } from "./crosscountrysuperad_shipmentreport.vue?vue&type=template&id=723f65fb&"
import script from "./crosscountrysuperad_shipmentreport.vue?vue&type=script&lang=js&"
export * from "./crosscountrysuperad_shipmentreport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports